import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [selectedLang, setSelectedLang] = useState('id');

  useEffect(() => {
    const storedLang = localStorage.getItem('selectedLang');
    if (storedLang) {
      setSelectedLang(storedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    setSelectedLang(lang);
    localStorage.setItem('selectedLang', lang);
  };

  return (
    <LanguageContext.Provider value={{ selectedLang, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
